import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/partners/AUDIBLE.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BITVAVO.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/COCA.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/COINGECKO.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/FREECASH.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/GOMINING.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/HELIUM_MOBILE.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/KRAKEN.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/MORALIS.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NEAR_AI.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NEAR.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/NOOM.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/PRODEGE.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/PROPHETMARKET.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/SWEATCOIN.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/UPLAND.svg");
;
import(/* webpackMode: "eager" */ "/app/public/wheel.png");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/PageSection/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/Button/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/PartnerLogo/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/partners/styles.module.css");
